import { v5 as O } from "uuid";
import { u as T, A as _ } from "./ConfigService-a05d127e.mjs";
import { s as x } from "./PreferenceService-ebb3b9de.mjs";
import { o as G, a as C } from "./UniqIdUtils-4a1244bc.mjs";
var f = /* @__PURE__ */ ((t) => (t.GET = "GET", t.POST = "POST", t.PUT = "PUT", t.DELETE = "DELETE", t.PATCH = "PATCH", t))(f || {});
const m = (t, e) => {
  const [r, ...o] = t, n = T.getConfigs(), a = {
    message: null,
    "log.level": e,
    IMAGE_TAG: n.IMAGE_TAG,
    "log.type": "CONSOLE_LOGS"
  }, s = {
    component: r.component,
    product: r.product
  }, i = !r.component && !r.product;
  return e === "ERROR" ? (a["err.message"] = o, a.message = i ? [] : [s]) : a.message = i ? o : [s, ...o], a["log.logger"] = r != null && r.page ? r == null ? void 0 : r.page : r == null ? void 0 : r.component, typeof window < "u" ? a : JSON.stringify(a);
}, k = {
  log: (...t) => console.log(m(t, "LOG")),
  info: (...t) => console.info(m(t, "INFO")),
  warn: (...t) => console.warn(m(t, "WARN")),
  error: (...t) => console.error(m(t, "ERROR")),
  debug: (...t) => console.debug(m(t, "DEBUG"))
}, F = {
  log: () => {
  },
  info: () => {
  },
  warn: () => {
  },
  error: () => {
  },
  debug: () => {
  }
}, R = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3
};
var H = Object.defineProperty, J = (t, e, r) => e in t ? H(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, h = (t, e, r) => (J(t, typeof e != "symbol" ? e + "" : e, r), r);
const L = class w {
  constructor(e) {
    h(this, "loggerObj"), h(this, "log"), h(this, "info"), h(this, "warn"), h(this, "debug"), h(this, "error"), h(this, "logLevelsCondition", (n) => {
      const a = T.getConfigs();
      switch (n) {
        case "info":
          return !a.LOG_LEVEL || R[a.LOG_LEVEL] <= R.INFO;
        case "warn":
          return !a.LOG_LEVEL || R[a.LOG_LEVEL] <= R.WARN;
        case "debug":
          return !a.LOG_LEVEL || R[a.LOG_LEVEL] <= R.DEBUG;
        case "error":
          return !a.LOG_LEVEL || R[a.LOG_LEVEL] <= R.ERROR;
        case "log":
        default:
          return !0;
      }
    }), h(this, "callOrReturnLog", (n) => {
      const { devMode: a } = x.getPreferences();
      return a ? console[n] : (...s) => {
        if (!this.logLevelsCondition(n))
          return;
        const i = s.flat(), l = i[i.length - 1], c = l && typeof l == "object" && n in l;
        (c ? [l] : w.loggersArr).forEach((p) => {
          p[n](this.loggerObj, ...c ? i.slice(0, i.length - 1) : s);
        });
      };
    });
    var r, o;
    this.loggerObj = {
      product: "",
      component: "",
      sessionId: (o = (r = _.getSession()) == null ? void 0 : r.session) == null ? void 0 : o.id,
      ...e
    }, this.log = (() => this.callOrReturnLog("log"))(), this.info = (() => this.callOrReturnLog("info"))(), this.warn = (() => this.callOrReturnLog("warn"))(), this.debug = (() => this.callOrReturnLog("debug"))(), this.error = (() => this.callOrReturnLog("error"))();
  }
  static getInstance(e) {
    return new w(e);
  }
};
h(L, "loggersArr", [k, F]), h(L, "setLoggers", (...t) => {
  L.loggersArr = [...t];
});
let V = L;
const b = V, d = {
  error: {
    E001: "URL not valid",
    E002: "Invalid Parameters",
    E003: "Body not provided!",
    E004: "Something went wrong",
    E005: "Request already in process",
    E006: "Bad Request",
    E007: "Request Timeout"
  },
  info: {
    I001: "API Cache initialized!!",
    I002: "Cached API requests:"
  },
  labels: {
    L001: "API Res",
    L002: "Response With Error"
  }
};
var W = Object.defineProperty, X = (t, e, r) => e in t ? W(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, q = (t, e, r) => (X(t, typeof e != "symbol" ? e + "" : e, r), r);
const j = class v {
  constructor() {
    q(this, "cache", /* @__PURE__ */ new Map()), q(this, "loggerServiceInstance", b.getInstance()), this.loggerServiceInstance.info(d.info.I001);
  }
  static getInstance() {
    return v.instance || (v.instance = new v()), v.instance;
  }
  /**
   * set url in an array
   * @param url string
   */
  pushUrl(e) {
    this.cache.set(e, !0);
  }
  /**
   * check weather url present in an array
   * @param url string
   * @returns booelan true/false
   */
  hasUrl(e) {
    return this.cache.has(e);
  }
  /**
   * remove items from array
   * @param url string
   */
  remove(e) {
    this.cache.delete(e);
  }
  /**
   * check cached URLs
   * DEBUGGING puposes
   */
  entries() {
    this.loggerServiceInstance.info(d.info.I002, this.cache);
  }
};
q(j, "instance");
let M = j;
const u = {
  LoggerServiceAlreadyLoaded: "Logger Service already loaded, using existing version",
  RequestStart: "API Request Start",
  RequestUrlAlreadyRequested: (t) => `%c ${t} is already requested`,
  RequestOptions: (t) => `%c Request Options: ${JSON.stringify(t, null, 2)}`,
  RequestComplete: "API Request Complete.",
  RequestError: "API Request error occurred",
  RequestInterceptorExecuted: "API Request Request Interceptors executed",
  RequestIdempotencyAdded: "API Request Idempotency key added.",
  ResponseConvertedToJSON: "API Request Response converted to JSON.",
  ResponseInterceptorExecuted: "API Request Response Interceptors executed",
  DefaultContentType: "Defaul content type added",
  RequestUrlCached: "Request url pushed to cacheInstance",
  RequestBodyParsed: "Request body parsed",
  DefaultErrorHandler: "Inside default error handlers",
  ReqeuestWithTraceId: "Request with traceId",
  SplunkSuccessfulLog: (t) => `%c Successfully Log sent to Splunk: ${t}`,
  SplunkFailedLog: (t) => `Failed Log Request with Status code: ${t}`,
  SplunkErrorLog: (t) => `Error while sending log to Splunk: ${t}`
}, N = function(t, e) {
  let r = {};
  if (t)
    if (t.ApiConfigService)
      ({ ApiConfigService: r } = t);
    else
      return t.ApiConfigService = r, e(r);
  return r;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(t) {
    let e = "", r = {};
    const o = () => e, n = (l) => {
      e = l;
    }, a = () => r, s = (l, c) => {
      r[l] = c;
    }, i = (l) => {
      r = l;
    };
    return t.getBaseUrl = o, t.setBaseUrl = n, t.getTuples = a, t.addTuple = s, t.setTuples = i, t;
  }
), S = {
  contentType: "Content-Type"
};
var K = Object.defineProperty, Q = (t, e, r) => e in t ? K(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, z = (t, e, r) => (Q(t, typeof e != "symbol" ? e + "" : e, r), r);
class A extends Error {
  constructor(e, r) {
    super(), z(this, "responseBody"), this.message = e, this.responseBodyArg = r, this.responseBody = r;
  }
}
var Y = Object.defineProperty, Z = (t, e, r) => e in t ? Y(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, U = (t, e, r) => (Z(t, typeof e != "symbol" ? e + "" : e, r), r);
class ee {
  /**
   * check if any errros are overriden from FE
   * @param options override or extend errors
   *
   */
  constructor(e = {}) {
    U(this, "overrideOptions", {}), U(this, "loggerServiceInstance", b.getInstance()), this.overrideOptions = e;
  }
  /**
   * check if any errros are overriden from FE
   * @param apiRes response of the api
   */
  async handlerErrors(e) {
    this.loggerServiceInstance.debug(d.labels.L001, e), this.overrideOptions[e.status] ? this.overrideOptions[e.status](e) : this.overrideOptions.default ? this.overrideOptions.default(e) : await this.handleDefaultErrors(e);
  }
  /**
   * handling deafult errors
   * @param apiRes response of the api
   */
  async handleDefaultErrors(e) {
    this.loggerServiceInstance.debug(u.DefaultErrorHandler);
    const r = e.headers.get(S.contentType);
    let o = {};
    switch (r != null && r.includes("json") && (o = await e.json(), this.loggerServiceInstance.debug(u.ResponseConvertedToJSON)), e.status) {
      case 400:
        throw new A(d.error.E006, o);
      default:
        throw new A(d.error.E004, o);
    }
  }
}
const te = (t) => new Promise((e) => {
  setTimeout(() => e(), t);
}), re = (t, e) => {
  const r = [`curl -X ${e.method || "GET"}`];
  if (e.headers)
    for (const [o, n] of Object.entries(e.headers))
      r.push(`-H "${o}: ${n}"`);
  if (e.body) {
    const o = typeof e.body == "object" ? JSON.stringify(e.body) : e.body;
    r.push(`--data '${o}'`);
  }
  return r.push(`"${t}"`), r.join(" ");
}, B = async (t, e) => {
  var r;
  const { retries: o, params: n, errorHandlers: a, delay: s = 0, retryOnStatus: i, customRetryFunction: l, ...c } = e, p = b.getInstance();
  if (!t)
    throw p.error(d.error.E001), new Error(d.error.E001);
  let E = t;
  n && (E = `${t}?${new URLSearchParams(n)}`);
  try {
    (r = process == null ? void 0 : process.env) != null && r.REQUEST_CURL_LOG && p.log(`Request curl: ${re(E, e)}`);
    const g = await fetch(E, c);
    return g.ok ? g : l ? l(t, e, g) : o && i != null && i.includes(g.status) ? (await te(s), B(t, {
      ...e,
      retries: o && o - 1
    })) : (p.error(d.labels.L002, E, e, g), await new ee(a).handlerErrors(g), g);
  } catch (g) {
    throw p.error(d.error.E004, "Error caught", g, E, e), g instanceof A ? g : new Error(d.error.E004);
  }
}, oe = G();
let P;
const y = (t, e) => new Promise((r, o) => {
  const n = b.getInstance();
  n.debug("Step-1", u.RequestStart), P = new AbortController();
  const a = T.getConfigs(), s = N.getBaseUrl(), i = M.getInstance(), l = (e == null ? void 0 : e.customCache) || !1, { url: c, timeout: p = a.NEXT_PUBLIC_REQUEST_TIMEOUT || 6e3 } = t, E = ne(t, e);
  if (l)
    if (i.hasUrl(c)) {
      n.debug("Step-6", u.RequestUrlAlreadyRequested(c), "color: red"), r({ res: d.error.E005 });
      return;
    } else
      i.pushUrl(c), n.debug("Step-6", u.RequestUrlCached);
  const g = setTimeout(() => {
    n.error({
      message: d.error.E007,
      status: 504
    }), P.abort(), o({ message: d.error.E007, status: 504 });
  }, p);
  B(c.indexOf("http://") === -1 && c.indexOf("https://") === -1 ? `${s}${c}` : c, E).then(async (I) => {
    const D = await ae(I, e);
    n.debug("Step-9", u.RequestComplete), r(D);
  }).catch((I) => {
    n.error(u.RequestError, I), o(I);
  }).finally(() => {
    clearTimeout(g), l && i.remove(c);
  });
});
y.get = (t, e) => y({ ...t, method: f.GET }, e);
y.post = (t, e) => y({ ...t, method: f.POST }, e);
y.put = (t, e) => y({ ...t, method: f.PUT }, e);
y.delete = (t, e) => y({ ...t, method: f.DELETE }, e);
y.patch = (t, e) => y({ ...t, method: f.PATCH }, e);
const $ = (t) => t || {}, se = (t, e) => {
  const r = b.getInstance();
  let o = { ...t };
  if (!(e != null && e.byPassInterceptors) && e != null && e.interceptors) {
    for (const n of e.interceptors)
      o = n == null ? void 0 : n.requestInterceptor(o);
    r.debug("Step-3", u.RequestInterceptorExecuted);
  }
  return o;
};
function ne(t, e) {
  var r;
  const o = b.getInstance();
  let n = {};
  const { signal: a } = P;
  e != null && e.skipDefaultContentType || (Object.assign(n, {
    [S.contentType]: "application/json"
  }), o.debug("Step-2", u.DefaultContentType));
  let s = t;
  const i = N.getTuples();
  n = {
    ...n,
    ...$(i)
  };
  const l = T.getConfigs();
  if ((typeof window > "u" || !window) && !l.NEXT_PUBLIC_OTEL_TRACING) {
    const c = O(s.url + G(), O.URL), p = `00-${C(32)}-${C(16)}-01`;
    n = {
      ...n,
      "X-Request-Id": c,
      //# traceparent value : {version}-{trace_id}-{span_id}-{trace_flags}
      traceparent: p
    }, o.debug(
      u.ReqeuestWithTraceId,
      `reqId: ${c}`,
      `traceparent: ${p}`,
      t
    );
  }
  if (s.headers = {
    ...n,
    ...$(s.headers)
  }, s = se(s, e), s.body && ((r = s.headers) == null ? void 0 : r[S.contentType]) === "application/json" && (s.body = JSON.stringify(s.body), o.debug("Step-4", u.RequestBodyParsed)), e != null && e.log && o.log(u.RequestOptions(s), "color: blue"), s.method === f.POST && (s.body || o.warn(d.error.E003)), (s.method === f.POST || s.method === f.PATCH || s.method === f.PUT) && !(e != null && e.skipIdempotency)) {
    if (s.headers = { ...s.headers }, e != null && e.customKeyGenerator) {
      const c = e.customKeyGenerator();
      s.headers["X-Idempotency-Key"] = c;
    } else {
      const c = O(s.url + oe, O.URL);
      s.headers["X-Idempotency-Key"] = c;
    }
    o.debug("Step-5", u.RequestIdempotencyAdded);
  }
  return {
    ...s,
    customRetryFunction: s.customRetryFunction,
    signal: a
  };
}
async function ae(t, e) {
  var r;
  const o = b.getInstance();
  let n = t;
  try {
    const a = t.headers.get(S.contentType);
    if (a != null && a.includes("json") && (n = await t.json(), o.debug("Step-7", u.ResponseConvertedToJSON)), e && !e.byPassInterceptors && e.interceptors) {
      for (let s = e.interceptors.length - 1; s >= 0; s--)
        n = (r = e.interceptors[s]) == null ? void 0 : r.responseInterceptor(n);
      o.debug("Step-8", u.ResponseInterceptorExecuted);
    }
    return n;
  } catch (a) {
    throw o.error(a), a;
  }
}
export {
  k as m,
  y as p
};
//# sourceMappingURL=Request-6aaae745.mjs.map
